import LottieLogo from "components/pages/lottie";
import { logoOptions } from "constants/lotties";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";
import { selectpriceTokens } from "store/selector/bestPriceCoins";
import { selectToken } from "store/selector/tokenStore";
import { addComma } from "utils/Format";
import { getTokenInfo } from "utils/getters";
import StaticHeaderInfo from "./staticHeaderInfo";
import TokenPriceState from "./tokenPriceState";

const HeaderInfoCoin = ({ allData }: any) => {
  const { t } = useTranslation();
  const stateList = useSelector(selectpriceTokens);
  const { tokenList } = stateList;
  useEffect(() => {}, [tokenList]);
  return (
    <StaticHeaderInfo>
      {tokenList.length ? (
        <Row className="mt-n7 mt-md-0">
          <>
            <Col
              xs="2"
              lg="1"
              xl="1"
              className="d-flex align-items-center justify-content-end"
            >
              <img src={allData.image} className="w-100" />
            </Col>
            <Col xs="10" lg="5" xl="5">
              <Row className="pt-2 ">
                <Col xs="2" lg="5" className="d-flex align-items-center ">
                  <span className="text-white fw-bold fs-2 text-nowrap fs-md">
                    {getTokenInfo(allData.symbol.toUpperCase(), "localeName")}
                  </span>
                </Col>
                <Col xs="10" lg="7">
                  <Row className="text-white  d-flex  align-items-center text-start">
                    <Col xs="9" lg="10">
                      <span className="fs-2 text-white fw-bold fs-md">
                        {addComma(
                          Number(
                            getTokenInfo(
                              allData.symbol.toUpperCase(),
                              "bestBuy","TMN"
                            )
                          )
                        )}
                      </span>
                    </Col>
                    <Col xs="2" lg="2">
                      <span className="fs-5 fs-sm text-secondary-five-light">
                        {t("Toman")}
                      </span>
                    </Col>{" "}
                  </Row>
                </Col>
              </Row>
              <Row className="mt-2 ">
                <Col xs="4" lg="6">
                  <div className="d-flex ">
                    <span className="text-white fs-5 text-nowrap fs-md ">
                      {allData.name}
                    </span>
                    <span className="text-secondary-one-light fs-5 fs-md px-1 d-none d-lg-block d-xl-block">
                      {`(${allData.symbol.toUpperCase()}) `}
                    </span>
                  </div>
                </Col>
                <Col xs="8" lg="6">
                  <Row className="text-white ">
                    <Col xs="9" lg="10">
                      <div className="d-flex justify-content-around align-items-center   ">
                        {allData.symbol != "usdt" ? (
                          <TokenPriceState
                            value={getTokenInfo(
                              allData.symbol.toUpperCase(),
                              "change24Percentage"
                            )}
                            indicatorType="background"
                          />
                        ) : (
                          <></>
                        )}
                        <span className="fs-5 fs-md text-white ">
                          {allData.symbol === "usdt"
                            ? "1"
                            : addComma(
                                Number(
                                  getTokenInfo(
                                    allData.symbol.toUpperCase(),
                                    "bestBuy"
                                  )
                                )
                              )}
                        </span>
                      </div>
                    </Col>
                    <Col xs="2" lg="2">
                      <span className="fs-5 fs-sm text-secondary-five-light">
                        {t("Dollar")}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </>
        </Row>
      ) : (
        <LottieLogo options={logoOptions} />
      )}
    </StaticHeaderInfo>
  );
};
export default HeaderInfoCoin;
